export const getSixthAnalysesData = state => state.sixthAnalyses.all;
export const getSixthAnalysisData = state => state.sixthAnalyses.sixthAnalysis;
export const sixthAnalysesIsFetching = state => state.sixthAnalyses.loading.all;
export const sixthAnalysisIsFetching = state => state.sixthAnalyses.loading.sixthAnalysis;